/* istanbul ignore file */
export default function ErrorTestPage() {
  throw new Error('ERROR TEST');
  // eslint-disable-next-line no-unreachable
  return null;
}
